import { Typography } from "@mui/material";
import React from "react";
import "./Quotation.css";
import api from "../../components/services/api";
import { useParams, useLocation } from "react-router";
import { useState, useMemo } from "react";
import { useEffect } from "react";
import moment from "moment";
function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}
export default function Quotation() {
  const query = useQuery();

  let { id } = useParams();
  const [data, setData] = useState();
  const getData = async () => {
    const res = await api(`api/quotation/data?QuotationId=${id}`);
    const data = await res.data;
    setData(data);
  };
  useEffect(() => {
    getData();
  }, []);

  // const pageCount = Math.ceil(data?.detail?.length / 6)

  // for (let pageIndex = 0; pageIndex < pageCount; pageIndex++) {

  //     console.log(data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6))
  // }
  console.log(data);
  const pageCount = Math.ceil(data?.detail?.length / 6);
  const rows = [];
  for (let pageIndex = 0; pageIndex < pageCount; pageIndex++) {
    rows.push(
      <>
        <page className="quotation">
          <div className="header">
            <img src="/images/logo2.png" className="logo" />
            {/* <div className="header_title">
                        <h3 >SRITRANG LOGISTIC COMPANY LIMITED</h3>
                        <h6>136-136/1 Phatthalung Rd, Tambon Tubtiang, Amphoe MueangTrang, Trang, Thailand 92000 Tax ID : 0925550000247</h6>
                        <h5 >บริษัท ศรีตรังโลจิสติกส์ จำกัด </h5>
                        <h6 >136-136/1 ถนนพัทลุง ตำบลทับเที่ยง อำเภอเมืองตรัง จังหวัดตรัง เลขทะเบียน 0925550000247</h6>
                    </div> */}
            {query.get("BranchCode") === "Kantang" ? (
              <div
                className="header_title"
                style={{ width: "100%", }}
              >
                <h4>SRITRANG LOGISTIC COMPANY LIMITED</h4>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>บริษัท ศรีตรังโลจิสติกส์ จำกัด</h5>
                  <span>Kantang Branch (00001):
                  </span>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>สาขากันตัง (00001)
                  </span>
                  <span>198/52 Trang Kapoom Rd, Kantang Sub-district,
                  </span>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>
                  198/52 ถนนตรังคภูมิ ตำบลกันตัง อำเภอกันตัง จังหวัดตรัง 92110
                  </span>
                  <span>Kantang, Trang, Thailand 92110
                  </span>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>เลขทะเบียนนิติบุคคล: 0925550000247
                  </span>
                  <span>Tax: 0925550000247
                  </span>
                </div>
              </div>
            ) : query.get("BranchCode") === "Hatyai" ? (
              <div
                className="header_title"
                style={{ width: "100%", }}
              >
                <h4>SRITRANG LOGISTIC COMPANY LIMITED</h4>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>บริษัท ศรีตรังโลจิสติกส์ จำกัด</h5>
                  <span>Hatyai Branch (00004):</span>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>สาขาหาดใหญ่ (00004)</span>
                  <span>136 Nualkeaw Uthit Rd, Kho Hong Sub-district,</span>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>
                  136 ถนนนวลแก้วอุทิศ ตำบลคอหงส์ อำเภอหาดใหญ่ จังหวัดสงขลา 90110
                  </span>
                  <span>Hatyai, Songkhla, Thailand 90110</span>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>เลขทะเบียนนิติบุคคล: 0925550000247</span>
                  <span>Tax: 0925550000247</span>
                </div>
              </div>
            ) : (
              <div
                className="header_title"
                style={{ width: "100%",  }}
              >
                <h4>SRITRANG LOGISTIC COMPANY LIMITED</h4>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>บริษัท ศรีตรังโลจิสติกส์ จำกัด</h5>
                  <span>Head Quarter:</span>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>สำนักงานใหญ่</span>
                  <span>136-136/1 Phatthalung Rd, Tubtiang Sub-district,</span>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>
                    136-136/1 ถนนพัทลุง ตำบลทับเที่ยง อำเภอเมืองตรัง จังหวัดตรัง
                    92000
                  </span>
                  <span>Amphoe Mueang Trang, Trang, Thailand 92000</span>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>เลขทะเบียนนิติบุคคล: 0925550000247</span>
                  <span>Tax: 0925550000247</span>
                </div>
              </div>
            )}
          </div>
          {/* <div className="titleR">
            <h3>ใบเสนอราคา / Quotation </h3>
          </div>
          <div className="content">
            <div className="rowR">
              <p className="header_p">Customer Code </p>
              <p> {data?.CustomerCode}</p>
            </div>
            <div className="rowR">
              <p className="header_p">Quotation No.</p>
              <p> {data?.QuotationNo}</p>
            </div>
            <div className="rowR">
              <p className="header_p" style={{ whiteSpace: "nowrap" }}>
                Customer Name
              </p>
              <p> {data?.CustomerName}</p>
            </div>
            <div className="rowR">
              <p className="header_p">Quotation Date </p>
              <p> {moment(data?.QuotationDate).format("yyyy/MM/DD")}</p>
            </div>
            <div className="rowR">
              <p className="header_p" style={{ whiteSpace: "nowrap" }}>
                Customer Address
              </p>
              <p> {data?.CustomerAddress}</p>
            </div>
            <div className="rowR">
              <p className="header_p">Sale Name </p>
              <p> {data?.EmpFullName}</p>
            </div>
            <div className="rowR">
              <p className="header_p">Contract Person</p>
              <p> {data?.ContractName}</p>
            </div>
            <div className="rowR">
              <p className="header_p">Address </p>
              <p> {data?.EmpAddress}</p>
            </div>
            <div className="rowR">
              <p className="header_p">Fax No. </p>
              <p> {data?.Fax}</p>
            </div>
            <div className="rowR">
              <p className="header_p">Tel No. </p>
              <p> {data?.Telephone}</p>
            </div>
            <div className="rowR">
              <p className="header_p">E-Mail </p>
              <p> {data?.Email}</p>
            </div>
          </div>
          <div className="content_center">
            <div className="rowR first">
              <p className="header_p">Service Route </p>
              <p></p>
            </div>
            <div className="rowR">
              <p className="header_p">Port of Loading</p>
              <p>{data?.POL}</p>
            </div>

            <div className="rowR">
              <p className="header_p">Port of Discharge</p>
              <p>{data?.POD}</p>
            </div>
          </div>
          <div className="content">
            <div className="rowR">
              <p className="header_p">Commodity</p>
              <p> {data?.Commodity}</p>
            </div>
            <div className="rowR">
              <p className="header_p">Period</p>
              <p>
                {" "}
                {`${moment(data?.QuotationDateFrom).format(
                  "DD/MM/yyyy"
                )} to ${moment(data?.QuotationDateTo).format("DD/MM/yyyy")}`}
              </p>
            </div>
          </div>
          <div className="content" style={{ flexDirection: "column" }}>
           
            <p className="header_p" style={{ marginBottom: "0px" }}>
              Factory
            </p>
            {data?.factory
              ?.concat([{}, {}, {}, {}, {}])
              .slice(0, 5)
              ?.map((x, i) => (
                <p
                  style={{
                    marginBottom: "0px",
                    opacity: x?.FactoryName === undefined ? "0" : "1",
                  }}
                >
                  {" "}
                  {`${i + 1}. ${
                    x?.FactoryName === undefined ? "" : x?.FactoryName
                  }`}
                </p>
              ))}
          </div> */}
          <div
            class="content"
            style={{
              marginTop: "0px",
              marginBottom: "0px",
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
              justifyContent: "end",
              borderTop: "1px solid #000",
            }}
          >
            <span>F-MK-004</span>
            <h4>ใบเสนอราคา / Quotation</h4>
          </div>
          <div
            class="content"
            style={{ marginTop: "0px", justifyContent: "space-between" }}
          >
            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                Service Type:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}> {data?.ServiceType || "-"}</p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "40%" }}>
                Quotation No.:{" "}
              </p>
              <p style={{ flexBasis: "60%" }}> {data?.QuotationNo}</p>
            </div>

            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                Period:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}>
                {" "}
                {`${moment(data?.QuotationDateFrom).format(
                  "DD/MM/yyyy"
                )} to ${moment(data?.QuotationDateTo).format("DD/MM/yyyy")}`}
              </p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "40%" }}>
                Quotation Date:{" "}
              </p>
              <p style={{ flexBasis: "60%" }}>
                {moment(data?.QuotationDate).format("yyyy/MM/DD")}
              </p>
            </div>

            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                Port of Loading:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}> {data?.POL}</p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "40%" }}>
                Sale Name:{" "}
              </p>
              <p style={{ flexBasis: "60%" }}>{data?.EmpFullName}</p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%",whiteSpace:'nowrap' }}>
                Port of Discharge:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}> {data?.POD}</p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "40%" }}>
                Tel No.:{" "}
              </p>
              <p style={{ flexBasis: "60%" }}>{data?.user?.EmpMobile}</p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                {" "}
              </p>
              <p style={{ flexBasis: "80%" }}> </p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "40%" }}>
                E-Mail:{" "}
              </p>
              <p style={{ flexBasis: "60%" }}>{data?.user?.email}</p>
            </div>

            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "14%" }}>
                Customer Code:{" "}
              </p>
              <p style={{ flexBasis: "86%" }}> {data?.CustomerCode}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "14%" }}>
                Customer Name:{" "}
              </p>
              <p style={{ flexBasis: "86%" }}> {data?.CustomerName}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "14%" }}>
                Customer Address:{" "}
              </p>
              <p style={{ flexBasis: "86%" }}> {data?.CustomerAddress}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Contract Person:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}>{data?.ContractName}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Tel / Fax No.:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}>{data?.Telephone} / {data?.Fax || "-"}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                E-Mail:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}>{data?.Email || "-"}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%", marginTop: "10px" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Factory Name:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}>
                {" "}
                {data?.factory
                  ?.concat([{}, {}])
                  .slice(0, 2)
                  ?.map((x, i) => (
                    <p
                      style={{
                        marginBottom: "0px",
                        opacity: x?.FactoryName === undefined ? "0" : "1",
                      }}
                    >
                      {" "}
                      {`${i + 1}. ${
                        x?.FactoryName === undefined ? "" : x?.FactoryName
                      }`}
                    </p>
                  ))}
              </p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Commodity:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}> {data?.Commodity}</p>
            </div>
          </div>
          <div className="containerR">
            <table border="1" cellpadding="10" cellspacing="0">
              <tr style={{ border: "1px solid" }}>
                <th style={{ border: "1px solid" }}>Code</th>
                <th style={{ border: "1px solid" }}>Service Description</th>
                <th style={{ border: "1px solid", width: "43px" }}>Size</th>
                <th style={{ border: "1px solid" }}>Unit Price</th>
                <th style={{ border: "1px solid", width: "30px" }}>Quantity</th>
                <th style={{ border: "1px solid", width: "43px" }}>Tax %</th>
                <th style={{ border: "1px solid", width: "100px" }}>Total</th>
                <th style={{ border: "1px solid", width: "30px" }}>Currency</th>
              </tr>

              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]
                      ?.Code
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]
                      ?.PriceNo
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]
                      ?.Size
                  }
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.detail
                    ?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]
                    ?.Unitprice.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]
                      ?.Qty
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]
                      ?.Tax
                  }
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.detail
                    ?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]
                    ?.TotalAmount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]
                      ?.CurrencyCode
                  }
                </td>
              </tr>

              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[1]
                      ?.Code
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[1]
                      ?.PriceNo
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[1]
                      ?.Size
                  }
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.detail
                    ?.slice(pageIndex * 6, pageIndex * 6 + 6)[1]
                    ?.Unitprice.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[1]
                      ?.Qty
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[1]
                      ?.Tax
                  }
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.detail
                    ?.slice(pageIndex * 6, pageIndex * 6 + 6)[1]
                    ?.TotalAmount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[1]
                      ?.CurrencyCode
                  }
                </td>
              </tr>

              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[2]
                      ?.Code
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[2]
                      ?.PriceNo
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[2]
                      ?.Size
                  }
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.detail
                    ?.slice(pageIndex * 6, pageIndex * 6 + 6)[2]
                    ?.Unitprice.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[2]
                      ?.Qty
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[2]
                      ?.Tax
                  }
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.detail
                    ?.slice(pageIndex * 6, pageIndex * 6 + 6)[2]
                    ?.TotalAmount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[2]
                      ?.CurrencyCode
                  }
                </td>
              </tr>

              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[3]
                      ?.Code
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[3]
                      ?.PriceNo
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[3]
                      ?.Size
                  }
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.detail
                    ?.slice(pageIndex * 6, pageIndex * 6 + 6)[3]
                    ?.Unitprice.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[3]
                      ?.Qty
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[3]
                      ?.Tax
                  }
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.detail
                    ?.slice(pageIndex * 6, pageIndex * 6 + 6)[3]
                    ?.TotalAmount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[3]
                      ?.CurrencyCode
                  }
                </td>
              </tr>

              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[4]
                      ?.Code
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[4]
                      ?.PriceNo
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[4]
                      ?.Size
                  }
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.detail
                    ?.slice(pageIndex * 6, pageIndex * 6 + 6)[4]
                    ?.Unitprice.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[4]
                      ?.Qty
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[4]
                      ?.Tax
                  }
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.detail
                    ?.slice(pageIndex * 6, pageIndex * 6 + 6)[4]
                    ?.TotalAmount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[4]
                      ?.CurrencyCode
                  }
                </td>
              </tr>

              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[5]
                      ?.Code
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[5]
                      ?.PriceNo
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[5]
                      ?.Size
                  }
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.detail
                    ?.slice(pageIndex * 6, pageIndex * 6 + 6)[5]
                    ?.Unitprice.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[5]
                      ?.Qty
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[5]
                      ?.Tax
                  }
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.detail
                    ?.slice(pageIndex * 6, pageIndex * 6 + 6)[5]
                    ?.TotalAmount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[5]
                      ?.CurrencyCode
                  }
                </td>
              </tr>

              <tr style={{ border: "1px solid", fontSize: "16px" }}>
                <td
                  valign="top"
                  rowspan="3"
                  colspan="3"
                  style={{ border: "1px solid" }}
                >
                  {/* {`Remark   ${data?.Remark}`} */}
                </td>
                <td colspan="2" align="left" style={{ border: "1px solid" }}>
                  Total
                </td>
                <td colspan="2" align="right" style={{ border: "1px solid" }}>
                  {data?.TotalNoTax.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td colspan="2" style={{ border: "1px solid" }}>
                  {data?.CurrencyCode}
                </td>
              </tr>
              <tr style={{ border: "1px solid", fontSize: "16px" }}>
                <td colspan="2" align="left" style={{ border: "1px solid" }}>
                  Tax
                </td>
                <td colspan="2" align="right">
                  {data?.TotalTax.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td style={{ border: "1px solid" }}>{data?.CurrencyCode}</td>
              </tr>
              <tr style={{ border: "1px solid", fontSize: "16px" }}>
                <td colspan="2" align="left" style={{ border: "1px solid" }}>
                  Total Amount
                </td>
                <td colspan="2" align="right">
                  {data?.TotalAmount.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td style={{ border: "1px solid" }}>{data?.CurrencyCode}</td>
              </tr>
              <tr height="50px">
                <td valign="top" colspan="8" style={{ fontSize: "16px" }}>
                  {`Service Condition   ${data?.InternalNote}`}
                </td>
              </tr>
              <tr height="50px">
                <td
                  valign="top"
                  colspan="8"
                  style={{ fontSize: "16px", border: "1px solid" }}
                >
                  {`Remark   ${data?.Remark}`}
                </td>
              </tr>
            </table>
          </div>

          <div className="content_footer">
            <div className="rowR" style={{ flexBasis: "30%" }}>
              <p style={{ lineHeight: "24px" }}>
                ______________________________
              </p>
              <p>(.........................................................)</p>
              <p>Authorized of the Company</p>
              <p>Date.............../.............../...............</p>
            </div>
            <div className="rowR" style={{ flexBasis: "30%" }}>
              <p style={{ lineHeight: "24px" }}>
                ______________________________
              </p>
              <p>(.........................................................)</p>
              <p>Sale</p>
              <p>Date.............../.............../...............</p>
            </div>
            <div className="rowR" style={{ flexBasis: "30%" }}>
              <p style={{ lineHeight: "24px" }}>
                ______________________________
              </p>
              <p>(.........................................................)</p>
              <p>Marketing Manager</p>
              <p>Date.............../.............../...............</p>
            </div>
          </div>
          {/* <div className="footerR">
            <p>SRITRANG LOGISTIC COMPANY LIMITED</p>
            <p>
              {" "}
              F-MK-004 ฉบับแก้ไขครั้งที่ ..... วันที่อนุมัติใช้
              ........./........../..........
            </p>
          </div> */}
        </page>
        {/* <div style={{ pageBreakAfter: "always" }}></div> */}
      </>
    );
  }
  return <>{rows}</>;
}
